import { render, staticRenderFns } from "./soc-mod@.vue?vue&type=template&id=81af6858&"
import script from "./soc-mod@.vue?vue&type=script&lang=ts&"
export * from "./soc-mod@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports